module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/Barry-S2.d94b769.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/Barry-S2.jpg
// module id = R8G0
// module chunks = 0